(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["le-lick-community-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-community-focus-email]');
    if (!trigger) return;
    // Prefer the visible sign-up field in the same footer, then any visible one on the page.
    var scope = trigger.closest('.footer-content') || document;
    var fields = Array.prototype.slice.call(scope.querySelectorAll('input[type="email"]'));
    if (scope !== document) {
      fields = fields.concat(Array.prototype.slice.call(document.querySelectorAll('input[type="email"]')));
    }
    var email = fields.find(function (field) {
      return field.offsetParent !== null;
    });
    if (!email) return;
    email.scrollIntoView({ behavior: 'smooth', block: 'center' });
    email.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
